export const authenticationModuleNames = {
	SIGN_IN: "Sign In",
	SIGN_UP: "Sign Up",
	OTP_VERIFICATION: "Otp Verification",
	FORGOT_PASSWORD: "Forgot Password",
	FORGOT_PASSWORD_OTP: "Forgot Password Otp"
};

export const authentication = {
	error: {
		INVALID_EMAIL_PASSWORD: "Invalid email or password. Please try again.",
		INVALID_EMAIL: "Invalid email. Please try again.",
		REQUIRED_EMAIL: "Please enter your registered email address",
		ALREADY_REGISTERED: "An account is already registered. Please login",
		EMAIL_ALREADY_EXISTS:
			"An account with the given email id already exists. Please login using that email id.",
		ERROR_OCCURRED: "An error occurred. Please try again.",
		FAILED_RESENT_OTP: "Failed to resend OTP. Please try again.",
		NEW_PASSWORD_REQUIRED: "New password is required."
	},
	success: {
		OTP_SENT_SUCCESS: "Otp sent successfully",
		VERIFICATION_CODE_SENT_SUCCESS_EMAIL:
			"Verification code sent to your email successfully. Please verify your account by entering the code.",
		CODE_SENT_SUCCESS: "Code sent successfully",
		OTP_RESENT_SUCCESS: "OTP has been resent successfully.",
		PASSWORD_CHANGED_SUCCESS: "Password changed successfully",
		ACCOUNT_VERIFIED_SUCCESS: "Account verified successfully"
	}
};

export const amplifyAuthErrors = {
	INCORRECT_USERNAME_PASSWORD: "Incorrect username or password.",
	USER_NOT_EXIST: "User does not exist.",
	USER_NOT_CONFIRMED: "User is not confirmed.",
	ACCOUNT_ALREADY_EXIST: "An account with the given email already exists."
};

export const errors = {
	SOMETHING_WENT_WRONG: "Something went wrong",
	USER_NOT_ALLOWED: "User not allowed to access the resource",
	NOT_REGISTERED_FOR_EVENT:
		"It looks like you’re not registered for this event. Please log in using the email address you registered with."
};

export const galleryAccess = {
	PRIVATE: 2,
	PUBLIC: 1
};

// Events where face search is allowed without authentication
export const PUBLIC_FACE_SEARCH_EVENTS: string[] = [
	"4fb6c39e-5895-4142-bcaf-9a0a8e31c5ab", // Dev event
	"bd541825-41a5-4bff-befc-52564a24844e", //Dev event
	"73f07d1b-2a0c-4de5-a44c-67174abbe228", // Staging event
	"f5850256-4b83-4cf9-b12f-cd9b1095ba4e", // Production event
	"88e3f120-acd9-43d3-a051-716e5940401d" // Production event
];
